import { Box, Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import ReusableTable1 from "../../components/table";
import { getGoogleCalendarEvents, googleAuthentication, sendGooglecode } from "../../services";
import Images from "../../assets";

const Calendar = () => {
  const [signinState, setSigninState] = useState(false);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState("");
  const getEvents = async () => {
    try {
      const response = await getGoogleCalendarEvents();
      if (response.success) {
        setEvents(response.data.items);
        setSigninState(false);
      } else {
        setSigninState(true);
      }
    } catch (err) {
      setSigninState(true);

    }
  };


  const fetchData = async () => {
    setLoading(true)
    try {
      const response = await googleAuthentication();
      window.location.href = response.data.data;
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  };

  const googleData = () => {
    fetchData();
  };

  useEffect(() => {
    const getCodeFromURL = async () => {
      try {
       
        if (code) {
          const response = await sendGooglecode(code);
          setEvents(response.data.items);
          window.location.href="/calendar-events"
          const currentUrl = window.location.href.split("?")[0];
          window.history.replaceState({}, document.title, currentUrl);
        }
      } catch (error) {
      }
    };
    const urlParams = new URLSearchParams(window.location.search);
    const receivedCode: any = urlParams.get("code");
    setCode(receivedCode);
    if(receivedCode){
      getCodeFromURL();
    }else{
      getEvents();
    }
  }, [code]);

  const columns = [
    { key: "attendees", name: "Attendees", minWidth: 170 },
    { key: "description", name: "Description", minWidth: 170 },
    { key: "startTime", name: "Start Time", minWidth: 170 },
    { key: "endTime", name: "End Time", minWidth: 170 },
    { key: "duration", name: "Duration", minWidth: 170 },
    { key: "hangoutLink", name: "Meeting link", minWidth: 170 }
  ];

  const transformEventData = (events: any) => {
    return events?.map((event: any) => {
      const attendees = event?.attendees?.map((att: any) => att.email).join(', ');
      const description = event?.description || 'N/A';
      const startTime = new Date(event?.start?.dateTime).toLocaleDateString('en-US', { 
        month: 'long', 
        day: 'numeric', 
        year: 'numeric' 
      }) + ', ' + 
      new Date(event?.start?.dateTime).toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: 'numeric', 
        hour12: true, 
        timeZone: event?.start?.timeZone 
      });
      const endTime = new Date(event?.end?.dateTime).toLocaleDateString('en-US', { 
        month: 'long', 
        day: 'numeric', 
        year: 'numeric' 
      }) + ', ' + 
      new Date(event?.end?.dateTime).toLocaleTimeString('en-US', { 
        hour: 'numeric', 
        minute: 'numeric', 
        hour12: true, 
        timeZone: event?.end?.timeZone 
      });
      const duration = ((new Date(event?.end?.dateTime).getTime() - new Date(event?.start?.dateTime).getTime()) / (1000 * 60)).toString() + ' mins';
      const hangoutLink = event?.hangoutLink ? <a href={event?.hangoutLink} rel="noreferrer" target="_blank" style={{ textDecoration: "none" }}>Join Meeting</a> : 'No link provided';

      return {
        attendees,
        description,
        startTime,
        endTime,
        duration,
        hangoutLink
      };
    });
  };

  const transformedEventData = transformEventData(events);
  const data = transformedEventData;

  return (
    <div >
      {signinState ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            sx={{
              backgroundColor: "#489797",
              borderRadius: "6px",
              color: "white",
              textTransform: "none",
              margin: "8px",
              boxShadow: "none",
              textAlign: "center",
              "&:hover": {
                backgroundColor: "#489797",
              },
            }}
            onClick={googleData}
            variant="contained"
          >
            {loading ? (
              <img
                src={Images.standardLoader}
                alt="load"
                style={{
                  width: "20px",
                  height: "20px",
                  padding: "5px",
                }}
              />
            ) : (
              "Sign in"
            )}
          </Button>
        </Box>
      ) : (
        <ReusableTable1 columns={columns} data={data} />
      )}

    </div>
  );
};

export default Calendar;
